import { IAdminPosTypeResponse } from '../../interfaces/admin-pos-type.interface'

export interface AdminPosTypeStateModel {
  shopPosType: IAdminPosTypeResponse
}
